import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';

export interface WaterBasic {
  id: number;
  title: string;
  countryName: string | null;
  countryId: number | null;
}

export interface WatersResult {
  waters: WaterBasic[];
  hasMore: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class WatersService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiUrl;

  getWaters(search?: string): Observable<WatersResult> {
    const params: Record<string, string> = {};
    if (search) {
      params['search'] = search;
    }
    return this.http.get<WatersResult>(`${this.baseUrl}/api/waters`, { params });
  }

  getWater(waterId: number): Observable<WaterBasic | undefined> {
    return this.http.get<WaterBasic | undefined>(`${this.baseUrl}/api/waters/${waterId}`);
  }
}
